import { useState } from "react";
import { useTranslation } from "react-i18next";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import { ConfirmationDialog } from "../../shared/ConfirmationDialog";
import type { WorkflowReducer } from "../workflowReducer";
import { MeasurementsOrderedTimeline } from "./MeasurementTimeline/MeasurementsOrderedTimeline";

interface Props {
  workflowReducer: WorkflowReducer;
  editMode?: boolean;
}

export function MeasurementsOrderTab(props: Props) {
  const { t } = useTranslation();
  const [showResetOrderConfirmation, setShowResetOrderConfirmation] = useState(false);

  function openResetOrderConfirmation() {
    setShowResetOrderConfirmation(true);
  }

  function closeResetOrderConfirmation() {
    setShowResetOrderConfirmation(false);
  }
  function handleAccept() {
    props.workflowReducer.resetMeasurementsOrder();
    closeResetOrderConfirmation();
  }

  return (
    <>
      {props.editMode && (
        <Stack direction="row" justifyContent="flex-end" sx={{ mt: 2 }}>
          <Button
            variant="outlined"
            onClick={openResetOrderConfirmation}
            disabled={props.workflowReducer.state.orderedMeasurements.length === 0}
          >
            {t("workflows.resetOrder")}
          </Button>
        </Stack>
      )}
      {showResetOrderConfirmation && (
        <ConfirmationDialog
          header={t("workflows.resetOrderConfirmation")}
          message={t("workflows.resetOrderConfirmationDetailed")}
          onAccept={handleAccept}
          onClose={closeResetOrderConfirmation}
          visible={showResetOrderConfirmation}
          closeMessage={t("common.cancel")}
          icon="warning"
        />
      )}
      <MeasurementsOrderedTimeline workflowReducer={props.workflowReducer} editMode={props.editMode} />
    </>
  );
}
